import type { ReactNode } from "react";
import { SteuerRueckfrageHost } from "../SteuerRueckfrage";
import { toggleTheme } from "../../lib/theme";
import { Toasts } from "../Toast";
import { CookieEinstellungenKnopf, CookieHinweis } from "../CookieHinweis";
import { WEBSITE_URL } from "../../app/nav";
import { currentLang, t } from "../../lib/sprache";
import { PLATFORM_NAME } from "../../lib/marke";
import { ScrollToTop } from "./ScrollToTop";
import { CreatorOfficeLogo, RahmenKontext } from "./Logo";

/**
 * Schlanker Rahmen für den Weg vom neuen Konto bis zur Zahlung (Inhaber 13.10.2026: „erst registrieren und Tarif wählen,
 * alles andere danach“). Kein Portal-Menü, keine Einrichtungsschritte: nur Logo, die drei Etappen und der Inhalt. Wer hier
 * steht, erreicht nichts anderes als Tarifwahl, Zahlung, Hilfe und Abmelden.
 */
export function StartRahmen({ title, schritt, onSignOut, children }: { title: string; /** ohne Angabe: keine Etappen (eigenständige Seite wie „Zahlungsmethode ändern“) */ schritt?: 1 | 2 | 3; onSignOut?: () => void; children: ReactNode }) {
  const lang = currentLang();
  const site = WEBSITE_URL;
  const etappen = [t("Konto", "Account"), t("Tarif & Zahlung", "Plan & payment"), t("Einrichten", "Set up")];
  return (
    <>
      <title>{`${title} · ${PLATFORM_NAME}`}</title>
      <ScrollToTop />
      <a className="skip btn" href="#main">{lang === "en" ? "Skip to content" : "Zum Inhalt"}</a>
      <header className="webnav tk-start-kopf">
        <span className="brand co-brand"><CreatorOfficeLogo form="responsive" /></span>
        {onSignOut && <button type="button" className="quiet" onClick={onSignOut}>{t("Abmelden", "Sign out")}</button>}
      </header>
      <RahmenKontext.Provider value={true}>
        <main id="main" className="web tk-start">
          {schritt && <ol className="tk-start-etappen" aria-label={t("Ablauf", "Steps")}>
            {etappen.map((name, i) => (
              <li key={name} className={i + 1 === schritt ? "aktiv" : i + 1 < schritt ? "fertig" : undefined} aria-current={i + 1 === schritt ? "step" : undefined}>
                <span aria-hidden="true">{i + 1 < schritt ? "✓" : i + 1}</span>{name}
              </li>
            ))}
          </ol>}
          {children}
        </main>
      </RahmenKontext.Provider>
      <footer className="footer tk-start-fuss">
        <div className="row">
          <a href={lang === "en" ? `${site}/en/legal-notice.html` : `${site}/impressum.html`} target="_blank" rel="noreferrer">{t("Impressum", "Legal notice")}</a>
          <a href={`${site}/datenschutz.html`} target="_blank" rel="noreferrer">{t("Datenschutz", "Privacy")}</a>
          <a href={`${site}/agb.html`} target="_blank" rel="noreferrer">{t("AGB", "Terms")}</a>
          <CookieEinstellungenKnopf />
          <button type="button" onClick={toggleTheme}>{lang === "en" ? "Light / dark" : "Hell / Dunkel"}</button>
        </div>
      </footer>
      <CookieHinweis />
      <Toasts />
      <SteuerRueckfrageHost />
    </>
  );
}
